/** Public pages are independent of session state; old workspace links still open. */
export function entryRoute(url: URL) {
  const path = url.pathname.replace(/\/$/, "") || "/";
  const params = url.searchParams;
  if (path === "/vision") return "vision";
  if (path === "/product") return "product";
  if (params.get("agentWorkspace") === "1") return "agent-workspace";
  if (params.get("agentRender") === "1") return "agent-render";
  if (params.get("preview") === "agents") return "agent-preview";
  const workspaceLink =
    [
      "room",
      "thread",
      "mentionText",
      "invite",
      "library",
      "admin",
      "agentConnect",
      "preview",
    ].some((key) => params.has(key)) ||
    new URLSearchParams(url.hash.slice(1)).has("invite");
  if (workspaceLink || path === "/app" || path.startsWith("/oauth/"))
    return "workspace";
  // Mistyped or retired public paths land on the homepage, not sign-in.
  return "vision";
}
